import delegate from 'delegate';
import Store from '@/store';
import URL from '@/util/url';

const DEFAULT_CHECK_DISPLAY_TIMER = 1000;
const VIEWED_ATTR = 'data-mod-viewed';

class Tracker {
  constructor(globals) {
    this.globals = globals;
    if (!globals.LXAnalytics) {
      throw new Error('missing LXAnalytics');
    }

    // 上次滚动的距离
    this._lastCheckScrollTop = 0;
    // 统计模块展现的 interval
    this._intervalHandler = null;
    this._interval = DEFAULT_CHECK_DISPLAY_TIMER;

    this._binded = false;
  }

  getCommonTrackOptions(options = {}) {
    let trackOptions = {};
    try {
      const state = Store.state;
      const { bizlogintoken, currentPoi } = state;
      const customerId = state.billModule.customerId;
      const partnerId = state.partnerModule.id;
      const isWXApplet = URL.isWXApplet;
      trackOptions = {
        bizlogintoken,
        poiId: currentPoi.poiId || 0,
        customerId,
        partnerId,
        isWXApplet,
        ...options,
      };
      trackOptions.custom = {
        ...(trackOptions.custom || {}),
        ...options,
      };
    } catch (e) {
      trackOptions = {};
    }

    return trackOptions;
  }

  sendPV(cid) {
    this.globals.LXAnalytics('pageView', this.getCommonTrackOptions(), null, cid);
  }

  sendEvent(eventType, action, valLab, options = {}) {
    if (arguments.length === 1 || typeof action === 'object') {
      if (typeof action === 'object') {
        valLab = action;
      }
      action = eventType;
      eventType = 'moduleClick';
    }
    this.globals.LXAnalytics(eventType, action, this.getCommonTrackOptions(valLab), options);
  }

  // 曝光事件
  sendModuleView(bid, valLab, options) {
    this.sendEvent('moduleView', bid, valLab, options);
  }

  sendModuleClick(bid, valLab, options) {
    this.sendEvent('moduleClick', bid, valLab, options);
  }

  // 页面离开事件，页面停留时长
  sendPageDisappear(data, options) {
    const { currentTime, startTime, ...rest } = data;
    const valLab = (currentTime && startTime)
      ? {
        duration: currentTime - startTime,
        ...rest,
      }
      : data;
    this.globals.LXAnalytics('pageDisappear', valLab, options);
  }

  // 追踪标记tag
  sendTag(tagIdentifier, data) {
    this.globals.LXAnalytics('tag', tagIdentifier, data);
  }

  // 初始化模块加载
  initModuleTracker() {
    if (this._binded) {
      return;
    }

    this._binded = true;
    // 不监听 scroll 事件，通过 timeout 每隔一段事件查看模块的展现
    this._trackModuleDisplay();
    this._trackModuleClick();
  }

  dealWithPageChange = (cid) => {
    this.sendPV(cid);
    this.initModuleTracker();
    // 先处理一下没有展现的模块
    this._trackModuleDisplay();
    this._lastCheckScrollTop = 0;
  };

  // 暂时只支持 body 滚动
  _trackModuleDisplay = () => {
    clearTimeout(this._intervalHandler);

    this._intervalHandler = setTimeout(() => {
      const {
        scrollTop,
        winHeight,
      } = this._getMetrics();
      // TODO data-mod 可配置
      // 搜集页面中所有的 data-mod 节点
      if (scrollTop === this._lastCheckScrollTop && scrollTop !== 0) {
        this._trackModuleDisplay();
        return;
      }
      const els = Array.prototype.slice.call(document.querySelectorAll('[data-mod]'), 0);
      els.forEach((el) => {
        const offsetTop = el.offsetTop;
        if (el.hasAttribute(VIEWED_ATTR)) {
          return;
        }
        const moduleName = el.getAttribute('data-mod');
        const moduleBottom = offsetTop + el.offsetHeight;
        const viewportBottom = scrollTop + winHeight;

        if (
          ((moduleBottom > scrollTop) && (moduleBottom <= viewportBottom))
          || ((offsetTop >= scrollTop) && (offsetTop < viewportBottom))
        ) {
          this.sendModuleView(moduleName);
          el.setAttribute(VIEWED_ATTR, 'snt');
        }
      });

      this._trackModuleDisplay();
      this._lastCheckScrollTop = scrollTop;
    }, this._interval);
  }

  _trackModuleClick = () => {
    delegate(document, '[data-bid]', 'click', (e) => {
      const target = e.delegateTarget;
      const itemName = target.getAttribute('data-bid');
      if (!itemName) {
        return;
      }

      const itemParams = target.getAttribute('data-event-params');
      let valLab = {};
      if (itemParams) {
        try {
          valLab = JSON.parse(itemParams);
          valLab = {
            custom: valLab,
          };
        } catch (err) {
          throw new Error('解析事件参数失败');
        }
      }

      const cid = target.getAttribute('data-cid');
      const options = cid ? { cid } : null;

      this.sendEvent('moduleClick', itemName, valLab, options);
    });
  }

  _getParentNodeWidthModule(target) {
    if (target.tagName === 'BODY' || !target) {
      return null;
    }

    if (target.hasAttribute('data-mod')) {
      return target;
    }

    return this._getParentNodeWidthModule(target.parentNode);
  }

  _getMetrics() {
    return {
      scrollTop: document.documentElement.scrollTop || document.body.scrollTop || 0,
      winHeight: window.innerHeight,
    };
  }
}

const tracker = new Tracker(window);

export default tracker;
